import { Box, Typography } from "@mui/material";
import { FairPaySurveyResponseContext } from "contexts/FairPaySurveyResponse";
import { useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

import { fetcher } from "utils/api";

const styles = {
  container: {
    minHeight: "100vh",
    minWidth: "100vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#151F16",
    flexDirection: "column",
    textAlign: "center",
  },
  heading: {
    color: "#F7EE6F",
    fontWeight: 600,
  },
  paragraph: {
    color: "#ECEAE5",
    maxWidth: "80%",
    mb: 4,
  },
  secondParagraph: {
    color: "white",
    maxWidth: "75%",
    fontSize: "18px",
    fontWeight: 600,
  },
};

export default function GenerateResults() {
  const { fairPaySurveyResponse, setFairPaySurveyResponse } = useContext(
    FairPaySurveyResponseContext,
  );
  const [loading, setLoading] = useState<boolean>(true);

  const generateResults = async () => {
    if (!fairPaySurveyResponse) {
      return null;
    }

    try {
      const { surveyResponse } = await fetcher(
        `/api/organization/fair-pay-survey-responses/${fairPaySurveyResponse.surveyUuid}/generate`,
        "POST",
      );
      setFairPaySurveyResponse(surveyResponse);
      return surveyResponse;
    } catch {
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    generateResults();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!loading) {
    return <Navigate to="../results" replace={true} />;
  }

  return (
    <Box sx={styles.container}>
      <Typography variant="h3" paragraph sx={styles.heading}>
        Crunching your numbers
      </Typography>
      {!fairPaySurveyResponse?.integrationEmail ? (
        <>
          <Typography sx={styles.paragraph}>
            Give us a moment while we extract some numbers for you to determine
            your fair pay score.
          </Typography>
          <Typography sx={styles.secondParagraph}>
            Your data stays confidential.
          </Typography>
        </>
      ) : (
        <>
          <Typography sx={styles.paragraph}>
            Emails are scanned automatically to extract deal info like rates,
            brands, and deliverables — nothing else.
          </Typography>
          <Typography sx={styles.secondParagraph}>
            Your personal emails stay confidential.
          </Typography>
        </>
      )}
    </Box>
  );
}
